module.exports = __webpack_public_path__ + "static/img/12.67c245a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/12.jpg
// module id = CUYy
// module chunks = 26